<template>
  <div class="error-page">
    <div class="error-img-box">
      <img
        class="error-img"
        src="../assets/img-error.png"
        alt="溯源信息迷路了…"
        srcset="../assets/img-error@2x.png"
      />
    </div>
    <p class="error-tip" v-show="errorType === 'outdate'">
      超出溯源有效期(10天)
    </p>
    <p class="error-tip" v-show="errorType === 'outdate'">下次记得提前来啊</p>
    <p class="error-tip" v-show="errorType === 'error'">{{ errorDesc }}</p>
    <p class="error-tip" v-show="errorType === 'none-info'">
      {{ errorDesc }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    errorType: {
      type: String,
      default: "error"
    },
    errorDesc: {
      type: String,
      default: "溯源信息迷路了…"
    }
  },
  components: {}
};
</script>

<style lang="less">
.error-page .dd-header-container {
  border-bottom: 1px solid #e9e9e9;
}
.error-img-box {
  margin-top: 114.5px;
  text-align: center;
  margin-bottom: 51px;
  .error-img {
    width: 195px;
    height: auto;
  }
}
.error-tip {
  text-align: center;
  font-size: 15px;
  font-weight: 400;
  color: #898e8a;
  line-height: 0.8;
  padding: 0;
}
</style>
